// extracted by mini-css-extract-plugin
export var OptionsContainer = "options-module--OptionsContainer--432e3";
export var SectionContainer = "options-module--SectionContainer--3ed15";
export var TitleContainer = "options-module--TitleContainer--f490c";
export var iconContainer = "options-module--iconContainer--94e3c";
export var mainContainer = "options-module--mainContainer--7fbd8";
export var option = "options-module--option--6766d";
export var optionSelected = "options-module--option-selected--5c32c";